<template>
  <v-list flat>
    <v-list-item-group active-class="" multiple>
      <v-list-item :data-testid="`item-${item[itemKey]}`" class="checklist-item" :key="item[itemKey]" @click="onItemClicked(item)" v-for="item in value">
        <template v-slot:default="{ active }">
          <v-list-item-action class="checklist-item-action">
            <v-checkbox :input-value="item.checked" class="checklist-checkbox shrink mr-0 mt-0"
                        color="#3ac18f" height="18px"/>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title class="checklist-content-item">{{item[itemText]}}</v-list-item-title>
            <v-list-item-subtitle v-if="item.subtitle">{{item.subtitle}}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>

  export default {
    name: "CheckList",
    props: {
      value: {
        type: Array,
        required: true,
      },
      itemKey: {
        type: String,
        default: 'id',
      },
      itemText: {
        type: String,
        default: 'title',
      },
    },
    methods: {
      onItemClicked(item) {
        const newValue = [...this.value];
        newValue.splice(newValue.indexOf(item), 1, {...item, checked: !item.checked});
        this.$emit('click', newValue);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .v-list {
      padding: 0;
      .checklist-item {
          min-height: 20px;
          max-height: 20px;
          margin: 12px 0;
          padding-left: 0;
          padding-right: 0;

          &:first-child {
              margin-top: 0;
          }

          &:last-child {
              margin-bottom: 0;
          }
      }
  }

  .checklist-item-action {
    margin: 6px 5px 6px 0 !important;
  }

  .checklist-content-item {
    font-family: var(--primary-font-family);
    font-size: 12px;
    text-transform: initial;
  }

  .checklist-checkbox {
    margin: 0;
  }

</style>

<style lang="scss">

  .checklist-checkbox {
    .v-icon.v-icon {
      font-size: inherit;
    }
  }

</style>

